<template>
  <div class="footer">
    <a class="phone" href="tel:862128905288"><img :src="images.phoneIcon">电话咨询</a>
    <a class="apply" @click.prevent="apply"><img :src="images.applyIcon">预约咨询</a>
  </div>
</template>

<script>
import images from '@/utils/images.js'
export default {
    data () {
        return {
            images: images
        }
    },
    methods: {
        apply () {
            const ele = document.querySelector('.form')
            const parent = ele.parentNode
            const fontSize = parseInt(document.documentElement.style.fontSize) || 1;
            const top = parent.offsetTop + ele.offsetTop - 2.4 * fontSize
            setTimeout(() => {
                document.documentElement.scrollTop = top
                document.body.scrollTop = top
            }, 16)
        }
    }
}
</script>

<style lang="scss" scoped>
    .footer {
        background: #fff;
        position: fixed;
        padding: 30px;
        width: 100%;
        box-sizing: border-box;
        bottom: 0;
        font-size: 0;
        display: flex;
        z-index: 20;
        img {
            width: 50px;
            height: 50px;
            vertical-align: middle;
            margin-right: 12px;
        }

        a {
            text-decoration: none;
            display: inline-block;
            height: 88px;
            line-height: 88px;
            color: #fff;
            font-weight: bold;
            border-radius: 8px;
            flex: 1;

            &.phone {
                flex-basis: 222px;
                font-size: 28px;
                background: #003964;
            }

            &.apply {
                flex-basis: 462px;
                font-size: 48px;
                background: #aa8058;
                margin-left: 6px;
                vertical-align: bottom;
            }
        }
    }
</style>